<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import { periodizationBounds } from "@/Common/constants";

    export let periodization: number
    export let disabled = false
    export let onInput: () => void = () => {}

</script>

<div class="grid items-center">
    <SelectSlider class="col-span-3" {...periodizationBounds} {disabled}
        bind:value={periodization}
        on:input={onInput}
    />
    <span class="row-start-2 text-sm text-slate-400 self-start justify-self-start ml-1">{(periodizationBounds.min*100.0).toFixed(1)}%</span>
    <span class="justify-self-center text-center">{(periodization*100.0).toFixed(1)}<span class="text-slate-500 text-sm">%</span></span>
    <span class="text-sm text-slate-400 self-start justify-self-end mr-1">{(periodizationBounds.max*100.0).toFixed(1)}%</span>
</div>